
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface AppBadgeVariant {
    default: boolean;
    warning: boolean;
    info: boolean;
    danger: boolean;
    success: boolean;
    primary: boolean
    dark: boolean
}

interface AppBadgeSize {
    default: boolean;
    small: boolean
}

@Component
export default class AppBadge extends Vue {
    @Prop({ default: 'default' }) variant!: string
    @Prop({ default: 'default' }) size!: string;

    variants: AppBadgeVariant = {
        default: false,
        warning: false,
        info: false,
        danger: false,
        success: false,
        primary: false,
        dark: false
    }

    sizes: AppBadgeSize = {
        default: false,
        small: false,
    }

    get badgeClasses() {

        this.variants[this.variant as keyof AppBadgeVariant] = true;
        this.sizes[this.size as keyof AppBadgeSize] = true;
        return {
            'TRC-AppBadge': true,
            'TRC-AppBadge--Default': this.variants['default'],
            'TRC-AppBadge--Warning': this.variants['warning'],
            'TRC-AppBadge--Info': this.variants['info'],
            'TRC-AppBadge--Danger': this.variants['danger'],
            'TRC-AppBadge--Success': this.variants['success'],
            'TRC-AppBadge--Primary': this.variants['primary'],
            'TRC-AppBadge--Dark': this.variants['dark'],
            'TRC-AppBadge--SizeDefault': this.sizes['default'],
            'TRC-AppBadge--SizeSmall': this.sizes['small'],

        }
    }
}
